import "./Style.scss";
const Subtitle = ({ subtitle }) => <h2 className="subtitle">{subtitle}</h2>;

export default Subtitle;
